import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('banking-correspondents', storeModule.createStoreModule('banking-correspondents'))
